import template from './file-list.pug';
import controller from './file-list.controller';

const FileListComponent = {
  template,
  controller,
  bindings: {
    files: '=?',
    multiple: '<?',
    removable: '<?',
    viewOnly: '<?',
    onDownload: '&?',
  },
};

export default FileListComponent;



// WEBPACK FOOTER //
// ./client/components/file-list/file-list.component.js